module.exports = __webpack_public_path__ + "Server-Healthy-Kubernetes.2a889fb79c2d516dbc34c00c52d2c57d.hashedasset.svg";